import React from 'react';


function Footer() {

return (
<>


<br />
<div className="footer">


© Jashele TV 2019 <br />
Live API Data from <a href="https://www.themoviedb.org/" target="_blank">The Movie DB</a>

<br />
<br />


Built with React  <br />
<a href="https://reactjs.org/" target="_blank"><img src={require('./images/react48.png')} /></a>

<br />

A <a href="http://jasheletillman.me/" target="_blank">Jashele Tillman</a> Project

<br />
<br />

<center>--------<br /><a href="#Nav">Back to Top</a></center>

</div>


</>
)
}

export default Footer;